import { useMutation, useQuery, useQueryClient, queryOptions } from '@tanstack/react-query';
import { getMatchById, getMatchPreference, updateMatchPreferences, UpdateMatchPreferencesInput } from '@uplift/api';
import { BaseQueryOpts } from './baseTypes';


export const matchByIdQuery = (matchId: string) => {
  return queryOptions({
    queryKey: [ 'match', matchId ],
    queryFn: () => getMatchById(matchId),
    select: data => data.data,
  });
};

export const useMatchPreferenceQuery = (matchId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'match', matchId, 'preference' ],
    queryFn: () => getMatchPreference(matchId),
    select: data => data.data,
    ...opts,
  });
};


export const useUpdateMatchPreferencesMutation = (matchId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [ 'updateMatchPreference' ],
    mutationFn: (preferences: UpdateMatchPreferencesInput) => updateMatchPreferences(matchId, preferences),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [ 'match', matchId, 'preference' ] });
    }
  });
};
